/* limit quantity for tagged products in Smart Cart */
function limitItemQuantities() {
  setTimeout(() => {
    if (!Rebuy.SmartCart) {
      return;
    }
    /* pull in all the cart items */
    const cartItems = Rebuy.SmartCart.items();
    /* check for product tag and quantity, lower quantity if needed */
    cartItems.forEach((item) => {
      if (item.product?.tags.includes("Max1") && item.quantity > 1) {
        /* <-- this is the max quantity for tagged products */
        /* lower item quantity back to the maximum */
        Rebuy.Cart.setItemQuantity(
          item,
          1
        ); /* <-- this is the max quantity for tagged products */
      }
    });
  }, 300);
}

/* Jason - 11 Apr 2024 - slack request -  reset TPB free shipping minimum when select items are in the cart. */
function resetFreeShippingMinimum() {
  setTimeout(() => {
    if (!Rebuy.SmartCart) {
      return;
    }
    //pull all the items in the cart
    const items = Rebuy.SmartCart.items();
    //assume free shipping is not free
    let freeShipping = false;
    //SKUs to check for defined in theme.liquid (free_shipping_skus)

    //check for specific items by their product ID number
    items.forEach((item) => {
      if (free_shipping_skus.includes(item.sku) && Rebuy.SmartCart.progressBar) {
        //reset shipping minimum to zero
        Rebuy.SmartCart.progressBar.tiers[0].minimum = 0;
        freeShipping = true;
      }
    });

    //if item was not found, set shipping back to original amount
    if (!freeShipping && Rebuy.SmartCart.progressBar) {
      //free_shipping_threshold defined in theme.liquid
      Rebuy.SmartCart.progressBar.tiers[0].minimum = free_shipping_threshold;
    }
  }, 500);
}

/* Jason - 16 Apr 2024 - MSM Request - Remove unnecessary selling plans from SC */
function removeUnnecessarySellingPlans() {
  setTimeout(() => {
    if (!Rebuy) {
      return;
    }
    // Grab the subscription drop downs
    document.querySelectorAll(".rebuy-select.muted").forEach((select) => {
      const seenValues = new Set();
      let selectedOption = select.querySelector("option:checked"); // Find the currently selected option

      // Retrieve options within the select
      var opts = select.querySelectorAll("option");

      Array.from(opts).forEach((option) => {
        if (seenValues.has(option.value) && option !== selectedOption) {
          // Remove the option only if it's a duplicate and not the selected one
          option.remove();
        } else {
          // Otherwise, add the value to the set to track uniqueness
          seenValues.add(option.value);
        }
      });

      // After cleanup, check if the previously selected option still exists, if not, select it again
      if (selectedOption && !select.contains(selectedOption)) {
        // Append the previously selected option back and select it
        select.appendChild(selectedOption);
        selectedOption.selected = true;
      }
    });
  }, 500);
}

// Function that enriches the cart line item properties
function itemEnrichProperties(item) {
  if (!item) return null;

  const newProperties = Object.assign({}, item.properties);
  let propertyChanged = false;

  // _subscription line item property
  if (item.selling_plan_allocation) {
    if (newProperties._subscription !== 'true') {
      newProperties._subscription = 'true';
      propertyChanged = true;
    }
  }
  else if ('_subscription' in newProperties) {
    delete newProperties['_subscription'];
    propertyChanged = true;
  }

  // _selling_plan line item property
  const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id?.toString();
  if (sellingPlanId) {
    if (newProperties._selling_plan !== sellingPlanId) {
      newProperties._selling_plan = sellingPlanId;
      propertyChanged = true;
    }
  }
  else if ('_selling_plan' in newProperties) {
    delete newProperties['_selling_plan'];
    propertyChanged = true;
  }

  // _product_type line item property
  if (item.product_type) {
    if (newProperties._product_type !== item.product_type) {
      newProperties._product_type = item.product_type;
      propertyChanged = true;
    }
  }
  else if ('_product_type' in item.properties) {
    delete newProperties['_product_type'];
    propertyChanged = true;
  }

  // Only call the changeItem function if something was really changed
  // as calling this without the propertyChanged checking will result to
  // looping calls as this is being invoked from the "rebuy:cart.change" event.
  if (propertyChanged) {
    Rebuy.Cart.changeItem({
      line: Rebuy.Cart.getItemLineNumber(item),
      properties: newProperties
    });
  }
}

// Function that enriches the properties of the current cart line items
function cartLineItemsEnrichProperties() {
  setTimeout(() => {
    if (!Rebuy) {
      return;
    }
    for (const item of Rebuy.Cart.items()) {
      itemEnrichProperties(item);
    }
  }, 500);
}

//runs on page load
resetFreeShippingMinimum();
removeUnnecessarySellingPlans();

// Set up a listener to run the function whenever the cart changes
document.addEventListener("rebuy:cart.change", function () {
  limitItemQuantities();
  resetFreeShippingMinimum();
  removeUnnecessarySellingPlans();
  cartLineItemsEnrichProperties();
});

// _base_variant_id line item property
function updateBaseVariantIdProperty(event) {
  const selectedVariant = event.detail.product.selected_variant;
  if (selectedVariant?.metafields?.cart?.base_variant_id) {
    const baseVariantId = selectedVariant.metafields.cart.base_variant_id.split("/").pop();
    event.detail.product.properties._base_variant_id = baseVariantId;
  }
}

// Set up a listener to run the function whenever a product is added to cart
document.addEventListener("rebuy.beforeAdd", function (event) {
  updateBaseVariantIdProperty(event);
});
